import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccessAuthorizationHeaders } from "../../../api";
import { helpers } from "../../../packages/helpers";
import { CHAT_ACTIONS, GetFileApiCallback } from "../types";
import type { ActionStoreParams } from "../../../store";

const { getActionErrorText } = helpers.error;
const { downloadFile } = helpers.file;

type ActionParams = {
  traceId: string;
  fileId: string;
  fileName: string;

  getFileApi: GetFileApiCallback;
};

export const getFile = createAsyncThunk<void, ActionParams, ActionStoreParams>(
  CHAT_ACTIONS.GET_FILE,
  async ({ fileId, fileName, getFileApi }, { getState }) => {
    try {
      const headers = getAccessAuthorizationHeaders(getState());

      await downloadFile(getFileApi(fileId, { headers }), fileName);
    } catch (error) {
      const text = getActionErrorText(error);

      throw new Error(text);
    }
  }
);
